import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { BusinessPartnerModule } from '../business-partners/business-partner.module';
import { OpportunitiesGridComponent } from './opportunities-grid/opportunities-grid.component';
import { OpportunitiesPopupComponent } from './opportunities-popup/opportunities-popup.component';
import { OpportunitiesRoutingModule } from './opportunities.routing.module';
import { OpportunitiesService } from './opportunities.service';
import { ActivitiesGridComponent } from './opportunities-popup/activities-grid/activities-grid.component';
import { SalesProcessPlanPopupComponent } from './opportunities-popup/activities-grid/sales-process-plan-popup/sales-process-plan-popup.component';
import { EditActivitesPopupComponent } from './opportunities-popup/activities-grid/activities-edit-popup/activities-edit-popup.component';
import { AddSaleProcessPopupComponent } from './opportunities-popup/activities-grid/activities-edit-popup/add-sale-process-popup/add-sale-process-popup.component';
import { AddActivitiesPopupComponent } from './opportunities-popup/activities-grid/activities-edit-popup/add-activities-popup/add-activities-popup.component';
import { AnalysisNotesPopupComponent } from './opportunities-popup/activities-grid/analysis-notes-popup/analysis-notes-popup.component';
import { OpenServiceOrderPopupComponent } from './opportunities-popup/open-service-order-popup/open-service-order-popup.component';
import { ProposalModule } from '../proposal/proposal.module';
import { DistributorAdvancedSearchPopupComponent } from './opportunities-popup/distributor-advanced-search-popup/distributor-advanced-search-popup.component';
import { CopyProposalPopupComponent } from './opportunities-popup/copy-proposal-popup/copy-proposal-popup.component';
import { AttachmentsComponent, HistoryComponent } from 'projects/shared/src/public-api';
import { LinksComponent } from 'projects/sales/src/app/shared/components/links/links.component'


@NgModule({
  declarations: [
    OpportunitiesGridComponent,
    
    OpportunitiesPopupComponent,
    ActivitiesGridComponent,
    AnalysisNotesPopupComponent,
    
    SalesProcessPlanPopupComponent,

    EditActivitesPopupComponent,
    AddSaleProcessPopupComponent,
    AddActivitiesPopupComponent,
    
    OpenServiceOrderPopupComponent,
    DistributorAdvancedSearchPopupComponent,
    
    CopyProposalPopupComponent
  ],
  imports: [
    OpportunitiesRoutingModule,
    ProposalModule,
    BusinessPartnerModule,
    CommonModule,
    SharedModule,
    AttachmentsComponent,
    HistoryComponent,
    LinksComponent
  ],
  exports: [
    OpportunitiesGridComponent,
    OpportunitiesPopupComponent,
    
    ActivitiesGridComponent,
    AnalysisNotesPopupComponent,
    
    SalesProcessPlanPopupComponent,

    EditActivitesPopupComponent,
    AddSaleProcessPopupComponent,
    AddActivitiesPopupComponent,
    
    OpenServiceOrderPopupComponent
  ],
  providers: [OpportunitiesService]
})
export class OpportunitiesModule { }
